import type { LogEntry, LogEntryEvent } from "@skaile/workspaces/types";
import type { LogSink } from "./types.js";

export interface WsLogSinkOptions {
  /**
   * Transport send callback. Typically wired to `transport.send` on the
   * runner's `WebSocketServerTransport`. The transport already drops sends
   * when no client is connected — this sink does not buffer.
   */
  send: (event: LogEntryEvent) => void;
}

/**
 * Forwards every LogEntry recorded by LogStore as a `log_entry` AgentEvent
 * over the configured transport. Used by the runner to make container-side
 * structured logs visible to the platform gateway in real time. Historical
 * reads still go through SQLite — this sink is for live tail only.
 */
export class WsLogSink implements LogSink {
  private readonly send: (event: LogEntryEvent) => void;

  constructor(opts: WsLogSinkOptions) {
    this.send = opts.send;
  }

  write(entry: LogEntry): void {
    try {
      this.send({ type: "log_entry", entry });
    } catch {
      // Logging must never break the agent — drop on transport failure.
    }
  }

  writeBatch(entries: LogEntry[]): void {
    for (const e of entries) this.write(e);
  }

  close(): void {
    /* nothing to release — transport lifecycle is owned by the caller */
  }
}
